module.exports = __webpack_public_path__ + "static/media/SB.947a3c13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SB.svg
// module id = 2253
// module chunks = 7